var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18774,4.02252H9.75043v1.5H6.18774A.68854.68854,0,0,0,5.5,6.21027V17.78973a.68854.68854,0,0,0,.68774.68775H9.75043v1.5H6.18774A2.18775,2.18775,0,0,1,4,17.78973V6.21027A2.18775,2.18775,0,0,1,6.18774,4.02252ZM11.25,19.0498h1.5V17.5h-1.5Zm0-3.0996h1.5V14.40039h-1.5ZM11.25,22h1.5V20.59961h-1.5Zm0-15.3501h1.5V5.1001h-1.5Zm0-3.1001h1.5V2h-1.5Zm0,9.3003h1.5V11.2998h-1.5Zm0-3.1001h1.5V8.2002h-1.5Zm6.56226-5.72748H14.25208v1.5h3.56018A.68854.68854,0,0,1,18.5,6.21027V17.78973a.68854.68854,0,0,1-.68774.68775H14.25208v1.5h3.56018A2.18775,2.18775,0,0,0,20,17.78973V6.21027A2.18775,2.18775,0,0,0,17.81226,4.02252Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.d6e6fae8.svg";
export { ForwardRef as ReactComponent };